<template>
  <div
    class="entry-project"
    :class="{
      'is-active': project.id === currentProjectId
    }"
    :key="project.id"
    @click="$store.commit('setCurrentProjectId', project.id)"
  >
    <div class="entry-project__name">{{ project.name }}</div>
    <div class="entry-project__action" v-if="project.id !== 'all'">
      <button
        class="entry-project-settings"
        v-if="project.archive === 0"
        @click="$root.$emit('edit-project-popup', true)"
      >
        <ui-icon name="settings" />
      </button>
      <button
        class="btn btn-secondary"
        v-if="project.archive === 1"
        @click.stop="unarchive"
      >
        Restore
      </button>
    </div>
  </div>
</template>

<script>
import uiIcon from '../ui-kit/ui-icon.vue'
export default {
  components: { uiIcon },
  name: 'entry-project',
  props: {
    project: Object
  },
  computed: {
    currentProjectId() {
      const project = this.$store.getters.currentProject
      return project ? project.id : null
    }
  },
  methods: {
    unarchive() {
      this.$store.dispatch('unarchiveProject', this.project)
      this.$root.$emit('update-projects')
    }
  }
}
</script>

<style lang="scss">
.entry-project {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
  transition: 0.2s;
  &__name {
    padding: 0.25em 1rem;
    overflow: hidden;
    color: $white;
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: rgba($white, 0.075);
    border-radius: 1em;
    transition: 0.2s;
  }
  &__action {
    position: absolute;
    right: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: auto;
    padding: 0 1rem 0 4rem;
    background: linear-gradient(
      to left,
      rgba($gray-900, 0.9),
      rgba($primary, 0)
    );
    opacity: 0;
    transition: 0.2s;
    .btn {
      padding: 2px 8px;
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
    }
  }
  &:hover {
    background-color: rgba($primary, 0.8);
    .entry-project__action {
      opacity: 1;
    }
  }
  &.is-active {
    .entry-project__name {
      background-color: rgba($white, 0.1);
    }
    background-color: rgba($primary, 1);
  }
}

.entry-project-settings {
  padding: 0;
  color: $gray-300;
  font-size: 20px;
  text-decoration: none;
  background-color: transparent;
  border: 0;
  transition: 0.2s;
  &:hover {
    color: $white;
  }
  .ui-icon {
    display: block;
  }
}
</style>
